// extracted by mini-css-extract-plugin
export default {"wrapper":"create_wrapper__qbrBe","savePublishButtonsWrapper":"create_savePublishButtonsWrapper__-WNXj"};